export const mainPage = (state) => state.session.base.mainPage;
export const secondaryPage = (state) => state.session.base.secondaryPage;
export const notifications = (state) => state.session.notifications.notifications;
